import React from "react";
// import { Spinner } from "reactstrap";

const Overlay = () => {
	return <></>;
};

export default Overlay;
